import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';

@Injectable()
export class ClaimsService {

    constructor(
        private request: RequestService,
    ) {}

    public getClaims(): Observable<any> {
        const payload = {
            sleutel: {
                rij_aantal: 100
            }
        };

        return this.request.post('schade-dossier/opvragen/dossiers', payload);
    }

    public getClaimDetail(dossier_volgnummer: number): Observable<any> {
        const payload = {
            sleutel: {
                dossier_volgnummer: dossier_volgnummer
            }
        };

        return this.request.post('schade-dossier/opvragen/dossier-details', payload);
    }

    public getClaimActions(dossier_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            }
        };

        return this.request.post('schade-dossier/opvragen/dossier-acties', payload);
    }

    public getProcessSteps(dossier_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            },
            proces: {
                sm_processtap_navigatie_naar: null,
                sm_processtap_navigatie_van: null,
                sm_processtap_navigatie_volgende_indicatie: null
            }
        };

        return this.request.post('schade-melden/verstrekken/processtappen', payload);
    }

    public cancelClaim(dossier_volgnummer: number): Observable<any> {
        const ongedaan_reden_code = 'IMLD';
        const boodschap_code = '11650-14';
        const boodschap_akkoord_indicatie = 'J';

        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            },
            ongedaan_reden_code: ongedaan_reden_code,
            meldingen: [{
                boodschap_code: boodschap_code,
                boodschap_akkoord_indicatie: boodschap_akkoord_indicatie
            }]
        };

        return this.request.post('schade-melden/annuleren/dossier', payload);
    }

}
